module.exports = __webpack_public_path__ + "img/party.5e639afa.svg";